import styled from 'threads5/styles/styled';

import { Stack } from 'src/components-v2/Layout';
import { Typography } from 'src/components-v2/DataDisplay';
import { Image } from 'src/components-v2/Media';
import RichTextSwitch from '../RichTextSwitch';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

const AuthorStack = styled(Stack)({
  '& p': {
    marginBottom: '0 !important',
  },
  marginBottom: '16px',
});

const AuthorImage = styled('div')(() => {
  return {
    width: '49px',
    height: '49px',
    borderRadius: '100%',
    background: 'linear-gradient(48deg, #F3EBFE 0%, #F9DBFF 50%, #FEA9FF 100%)',
    flexShrink: 0,
  };
});

const Author = ({ node }) => {
  const { name, blurb, image } = node?.data?.target?.fields;
  const inspectorProps = useContentfulInspectorMode({
    entryId: node?.data?.target?.sys?.id,
  });

  return (
    <AuthorStack
      direction='row'
      gap={1.5}
      {...inspectorProps({
        fieldId: 'name',
      })}
    >
      {image && (
        <AuthorImage>
          <Image
            isLazy={true}
            src={`${image?.fields?.file?.url}?w=98&fm=webp&q=70&r=100`}
            sources={{
              // NOTE: we don't need to set breakpoints because the asset is the same size on all breakpoints
              xs: `${image?.fields?.file?.url}?w=49&fm=webp&q=70&r=100 1x, ${image?.fields?.file?.url}?w=98&fm=webp&q=70&r=100 2x`,
            }}
            alt={image?.fields?.description ?? image?.fields?.title ?? ''}
            width={49}
            height={49}
          />
        </AuthorImage>
      )}
      <Stack direction='column'>
        {name && (
          <Typography component='p' variant='p3'>
            <b>{name}</b>
          </Typography>
        )}
        {blurb && (
          <RichTextSwitch
            sys={node?.sys}
            content={blurb}
            nodes={{ p: { variant: 'p3', component: 'p' } }}
          />
        )}
      </Stack>
    </AuthorStack>
  );
};

export default Author;
